import { validateResponse, unwrapResponse } from "../../response.js";
import { authHeader, acceptJson, postJson } from "../../shared.js";
import { personalDetailsResponseSpec } from "./specs.js";
async function details(apiUrl, accessToken, customerId) {
  return validateResponse(
    personalDetailsResponseSpec,
    await fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/details`, {
      method: "GET",
      headers: {
        ...acceptJson,
        ...authHeader(accessToken)
      }
    })
  );
}
async function updateDetails(apiUrl, accessToken, customerId, request) {
  return unwrapResponse(
    await fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/details`, {
      method: "POST",
      headers: {
        ...acceptJson,
        ...postJson,
        ...authHeader(accessToken)
      },
      body: JSON.stringify(request)
    })
  );
}
export {
  details,
  updateDetails
};
//# sourceMappingURL=details.js.map
